<template>
    <div id="frequently-asked-questions" class="flex flex-col items-center mb-12">
        <h2 class="text-2xl text-san-marino-700 font-bold mb-8"
            >Sıkça Sorulan Sorular</h2
        >

        <Accordion class="w-full">
            <AccordionPanel
                v-for="question in questions"
                :key="question.header"
                :value="question.value">
                <AccordionHeader class="!bg-san-marino-100 border-san-marino-50 text-san-marino-700 text-lg text-left">{{ question.header }}</AccordionHeader>
                <AccordionContent>
                    <p class="mt-4">{{ question.content }}</p>
                </AccordionContent>
            </AccordionPanel>
        </Accordion>
    </div>
</template>

<script setup>
import { ref } from "vue";

const questions = ref([
    { header: "eSIM veri paketimin süresi ne zaman doluyor?", content: "eSIM veri paketinin sona erme tarihi, eSIM’in geçerliliğine veya veri tüketimine bağlıdır. eSIM veri paketiniz, tüm verileri bu tarihten önce tüketmediğiniz sürece sunulan geçerlilik süresi boyunca geçerli olacaktır. Geçerlilik süresi eSIM etkinleştirildiğinde başlar. Çoğu eSIM, kurulu eSIM hedefteki desteklenen ağa bağlandığında etkinleşir. eSIM'e bağlı olarak, konumunuza bakılmaksızın kurulum sırasında da etkinleştirilebilir.", value: "0" },
    { header: "eSIM’imi ne zaman kurabilirim?", content: "eSIM'inizi ne zaman yükleyebileceğinizi bilmek için etkinleştirme politikasından haberdar olmanız gerekir. Çoğu eSIM yalnızca varış noktasında, desteklenen bir ağa bağlandığında etkinleşir. Diğer yandan, konumdan bağımsız olarak yüklenir yüklenmez etkinleşen eSIM'ler de vardır.", value: "1" },
    { header: "Tethering (Kişisel Erişim Noktası) kullanabilir miyim?", content: "Evet, cihazınız ve ağ tarafından desteklendiği sürece kişisel erişim noktanızı eSIM’inizle kullanabilirsiniz.", value: "2" },
    { header: "eSIM’im ile 5G bağlantıyı kullanabilir miyim?", content: "Bazı Kolay eSIM'leri 5G'ye kadar olan hızlardaki hücresel veya mobil ağları destekler. Ancak, bu durum cihazınıza bağlı olarak farklılık gösterebilir. 5G ağlarının yalnızca bu teknolojinin desteklendiği ülkelerde ve bölgelerde mevcut olduğunu lütfen unutmayın.", value: "3" },
]);
</script>
